import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const Header = (props) => {
    const headingClassName =
        `sb-header__title ${props.mobileType === 'mobile' ? 'sb-header__title_mobile' : ''}`;

    const rpLogoClassName =
        `sb-header__rp-logo ${props.mobileType === 'mobile' ? 'sb-header__rp-logo_mobile' : ''}`;

    const wbLogoClassName =
        `sb-header__wb-logo ${props.mobileType === 'mobile' ? 'sb-header__wb-logo_mobile' : ''}`;

    return (
        <div className="sb-header">
            <div className="sb-header__wrapper">
                <div
                    className={headingClassName}
                >
                    <Svg
                        iconName="rpLogo"
                        className={rpLogoClassName}
                    />
                </div>
                <div className="sb-header__logo">
                    <Svg
                        iconName="WBLogoV"
                        className={wbLogoClassName}
                    />
                </div>
            </div>
            <div className="sb-header__description content container">
                <span>The Racing Post Stallion Book contains individual
                    profiles for over 2000 stallions including comprehensive
                    Racing Post data for all stallions
                    <span className="sb-header__description_ext">
                        &nbsp;plus additional Weatherbys data for those
                        included within the <strong>Weatherbys Stallion Book</strong>
                    </span>.
                </span>
            </div>
        </div>
    );
};

Header.propTypes = {
    mobileType: PropTypes.string
};

export default Header;



// WEBPACK FOOTER //
// ./src/client/components/Header.js